import * as React from 'react';
export const volksbankdeSvg = React.forwardRef(function volksbankdeSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fillRule: 'nonzero',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#E05F0C',
          d: 'M19.8 26.18c-.32 1.78-.61 5.2-.73 5.8H32v-5.8H19.8zm-19.8 0V32h12.83l-.86-5.82H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#0A438A',
          d: 'M20.35 24.73c.57-3.08 1.16-6.35 1.3-7 .2-.93 1.23-.81 1.08.12l-.24 1.68c-.13 1.21 2.63 1.36 2.95.06.83-3.39 1.27-6.5 1.27-6.5h-3.32c-4.61 0-4.92.8-5.72 4.19l-1.6 7.45h-.15l-2.57-11.64H5.38h.02l.93 4.36h3.65l1.65 7.28H0V0h32v24.73H20.35z',
        }),
      ),
    ),
  );
});
volksbankdeSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var volksbankde = {
  category: 'brand',
  colorable: false,
  name: 'volksbankde',
  svg: volksbankdeSvg,
};
